import { useReactiveVar } from '@apollo/client';
import React, { FC } from 'react';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import { vars } from '../../../reactive';

interface AnimationProps {
  animationKey: any;
  children: React.ReactNode;
}

const Animation: FC<AnimationProps> = ({ animationKey, children }) => {
  const formClass = useReactiveVar(vars.formClass);
  return (
    <SwitchTransition mode="out-in">
      <CSSTransition
        key={animationKey}
        addEndListener={(node, done) => {
          node.addEventListener('transitionend', done, false);
        }}
        classNames={formClass}
      >
        {children}
      </CSSTransition>
    </SwitchTransition>
  );
};

export default Animation;
